import fetch from 'unfetch'

const API_HOST = 'https://api.ncovjp.com'

let services = {}
services.getVisions = async () => {
  return await fetch(`${API_HOST}/api/visions`, {
    credentials: 'omit',
  }).then((response) => response.json())
}

export default services
